export enum EnvironmentName {
    DEV,
    MASTER_HU,
    MASTER_AT,
    MASTER_CH,
    STAGING_HU,
    STAGING_AT,
    STAGING_CH,
    PROD_HU,
    PROD_AT,
    PROD_CH,
    NONE_OF_THEM,
}
